module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_vi-01401d9327afac000dfd231003946266.jpg";